import { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { forgotPassword } from "../../api/AUTH/auth";
import logo from "../../assets/img/Icone_Niralakka_blanc.svg";
import loginBG from "../../assets/img/loginBG.png";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isDark, setIsDark] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const isDarkMode = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    setIsDark(isDarkMode);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-bs-theme') {
          setIsDark(document.documentElement.getAttribute('data-bs-theme') === 'dark');
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {

      await forgotPassword(email);
      
      setIsSubmitted(true);
      toast.success('Email de réinitialisation envoyé ! Vérifiez votre boîte de réception.');

    } catch (error) {

      toast.error(error?.message || "Erreur lors de l'envoi de l'email");
      setIsSubmitted(true);

    } finally {

      setIsLoading(false);
      
    }
  };

  return (
    <>
      <div className="login-bg-blur" style={{ backgroundImage: `url(${loginBG})`, filter: 'blur(12px)' }}></div>
      <div className="login-overlay" style={{ minHeight: "100vh", display: "flex", alignItems: "center", position: "relative", zIndex: 1 }}>
        <Container style={{ padding: '1rem' }}>
          <Row className="justify-content-center">
            <Col xl={5} lg={6} md={8} sm={10} xs={12}>
              <Card className="border-0" style={{ 
                overflow: "hidden", 
                borderRadius: "2rem",
                background: isDark ? "rgba(30, 30, 30, 0.6)" : "rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(50px)",
              }}>
                <div className="d-flex align-items-center justify-content-center" style={{
                  minHeight: "100px",
                  paddingTop: "15px",
                  paddingBottom: "10px"
                }}>
                  <img src={logo} alt="Logo" style={{ maxHeight: "80px", maxWidth: "90%", marginTop: "30px"}} />
                </div>

                <Row className="g-0">
                  <Col lg={12}>
                    <Card.Body className="login-card-body" style={{ minHeight: "auto", display: "flex", flexDirection: "column", justifyContent: "flex-start", paddingTop: "1.5rem" }}>
                      <div className="text-center mb-2">
                        <h1 className="login-welcome-title" style={{ color: 'white' }}>Mot de passe oublié</h1>
                      </div>
                      
                      {!isSubmitted ? (
                        <>
                          <div className={`text-center ${isDark ? 'login-text-muted' : 'login-text-muted-light'}`} style={{ marginBottom: "20px", color: !isDark ? 'white' : undefined }}>
                            <p className="h6">Entrez votre adresse email pour recevoir un lien de réinitialisation.</p>
                          </div>

                          <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formEmail">
                              <Form.Label className={`mb-2 ${isDark ? 'login-text-muted' : 'login-text-muted-light'}`} style={{ color: !isDark ? 'white' : undefined }}>
                                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
                                E-mail
                              </Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Entrez votre adresse e-mail..."
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                style={{ 
                                  borderRadius: "20px", 
                                  padding: "15px", 
                                  background: "rgba(255, 255, 255, 0.2)",
                                  border: `1px solid ${isDark ? 'var(--bs-gray-500)' : 'var(--bs-gray-300)'}`,
                                  color: "white"
                                }}
                                className="placeholder-white"
                              />
                            </Form.Group>

                            <Button
                              type="submit"
                              variant="primary"
                              className="w-75 mt-5 mx-auto d-block btn-primary"
                              disabled={isLoading}
                              style={{ borderRadius: "1rem", padding: "10px" }}
                            >
                              {isLoading ? (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />{" "}
                                  Envoi en cours...
                                </>
                              ) : (
                                "Envoyer le lien"
                              )}
                            </Button>
                          </Form>
                        </>
                      ) : (
                        <div className="text-center">
                          <div style={{ color: '#28a745', marginBottom: '20px', fontSize: '48px' }}>
                            ✓
                          </div>
                          <h4 style={{ color: 'white', marginBottom: '10px' }}>Email envoyé !</h4>
                          <p className={isDark ? 'login-text-muted' : 'login-text-muted-light'} style={{ color: !isDark ? 'white' : undefined }}>
                            Vérifiez votre boîte mail et cliquez sur le lien pour réinitialiser votre mot de passe.
                          </p>
                        </div>
                      )}

                      <Button
                        variant="link"
                        onClick={() => navigate('/')}
                        style={{
                          color: 'white',
                          textDecoration: 'none',
                          fontSize: '14px',
                          marginTop: '20px'
                        }}
                        className="p-0 d-flex align-items-center justify-content-center"
                      >
                        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
                        Retour à la connexion
                      </Button>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ForgotPassword;
